import { render } from "./ImageUploadPost.vue?vue&type=template&id=152ad558&scoped=true"
import script from "./ImageUploadPost.vue?vue&type=script&lang=js"
export * from "./ImageUploadPost.vue?vue&type=script&lang=js"

import "./ImageUploadPost.vue?vue&type=style&index=0&id=152ad558&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152ad558"]])

export default __exports__